import { configureStore } from '@reduxjs/toolkit';
import languageReducer from './slices/languageSlice';
import phrasesReducer from './slices/phrasesSlice';
import loadingOverlayReducer from './slices/loadingOverlaySlice';

const store = configureStore({
  reducer: {
    language: languageReducer,
    phrases: phrasesReducer,
    overlayState: loadingOverlayReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;